import { getApiUrl } from "@utils/baseUrl";

// Local dev only: set VITE_LOCAL_INTEL_HUB_API_URL (e.g. http://127.0.0.1:8001/trademo) in .env.local
// to send the AI Recommendations calls to a locally running search-shipments backend.
const env = (import.meta as ImportMeta & { env: { DEV?: boolean; VITE_LOCAL_INTEL_HUB_API_URL?: string } }).env;
const LOCAL_INTEL_HUB_API_URL = env.DEV ? env.VITE_LOCAL_INTEL_HUB_API_URL : "";

export const getIntelHubApiUrl = (path: string) => (LOCAL_INTEL_HUB_API_URL ? `${LOCAL_INTEL_HUB_API_URL.replace(/\/$/, "")}/${path}` : getApiUrl(path));
